import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationDE from "./locales/de/translate.json";

i18n.use(initReactI18next).init({
  resources: {
    de: {
      translation: translationDE,
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
  returnEmptyString: false,
  defaultNS: "translation",
});

export default i18n;
